'use client'

import { useCallback } from 'react'

import { FloatingModal } from '@/components/common/Floating'
import { useReduxDispatch, useReduxSelector } from '@/store/hooks'
import { modalActions, type ModalType } from '@/store/modal'

type ItemProps = {
  isFirst: boolean
  isTop: boolean
} & ModalType

const ModalsItem = ({ content, id, ...props }: ItemProps) => {
  const dispatch = useReduxDispatch()

  const setIsOpen = useCallback(() => dispatch(modalActions.close(id)), [dispatch, id])

  return <FloatingModal {...props} content={content} isOpen setIsOpen={setIsOpen} />
}

export const Modals = () => {
  const stack = useReduxSelector((s) => s.modal.stack)
  const firstId = stack[0]?.id
  const topId = stack.at(-1)?.id

  return stack.map(
    (modal) =>
      modal.content && (
        <ModalsItem {...modal} isFirst={modal.id === firstId} isTop={modal.id === topId} key={modal.id} />
      ),
  )
}
